export const NAVBAR_HEIGHT = 140

export const API_BASE_URL = '/api/'
export const WS_API_BASE_URL = `${window.location.protocol === 'https:' ? 'wss' : 'ws'}://${window.location.host}/ws/`

export const MAIN_ROUTE = '/'
export const LOGIN_ROUTE = '/login'
// export const REGISTRATION_ROUTE = '/registration'
export const CABINET_ROUTE = '/cabinet'
export const DEVICES_ROUTE = '/devices'
export const UNCKNOWN_ROUTE = '*'
export const TEST_ROUTE = '/test'


// export const USER = '/user'
// export const USER_BY_ID = (id) => `/user/${id}`
// export const LOGIN = '/user/login'
// export const REGISTER = '/user/register'
// export const EMPLOYEE = '/employee'
// export const EMPLOYEE_USER = (id) => `/employee/${id}/user`
// export const EMPLOYEE_POST = (id) => `/employee/${id}/post`
// export const THERAPY = '/therapy'
// export const THERAPY_BY_ID = (id) => `/therapy/${id}`
// export const PATIENT_THERAPY = (id) => `/patient/${id}/therapy`
// export const PATIENT_USER = (id) => `/patient/${id}/user`
// export const THERAPY_COMMENTS = (id) => `/therapy/${id}/comments`
// export const ILLNESS_PROFILE = '/illness-profile'
// export const ILLNESS_PROFILE_BY_ID = (id) => `/illness-profile/${id}`
// export const PATIENT_ILLNESS_PROFILE = (id) => `/patient/${id}/illness-profile`
